// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,600;0,700;1,500&family=Noto+Sans+KR:wght@400;500;600;700&family=Noto+Serif+KR:wght@500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 급여명세 — 연도 달력(월 선택) + 고급 문서 모달 */

/* 페이지 전체 가로 확장 */
.salary-page .settings-wrap {
  max-width: min(96vw, 1320px);
}

/* 급여 달력 + 연차 패널 가로 배치 */
.salary-leave-split {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(0, 1.15fr);
  gap: 20px;
  align-items: start;
}

.salary-leave-split .settings-card {
  margin: 0;
}

@media (max-width: 1024px) {
  .salary-leave-split {
    grid-template-columns: 1fr;
  }
}

.salary-cal-panel {
  max-width: none;
  width: 100%;
  margin: 0 auto;
  background: var(--mrt-surface, #fcfbfa);
  border: 1px solid var(--mrt-border, #e8e6e3);
  border-radius: 16px;
  padding: 20px 22px 24px;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.8) inset;
}

.salary-cal-hint {
  margin: 0 0 18px;
  font-size: 13px;
  color: var(--mrt-muted, #78716c);
  font-weight: 500;
  line-height: 1.5;
}

.salary-cal-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--mrt-border-2, #ebe8e4);
}

.salary-cal-nav__btn {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  border: 1px solid var(--mrt-border, #e0ddd8);
  background: var(--mrt-bg, #f4f3f1);
  color: var(--mrt-text, #1c1917);
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.salary-cal-nav__btn:hover {
  background: #ebe9e6;
  border-color: #d4d0c8;
}

.salary-cal-nav__btn:active {
  transform: scale(0.98);
}

.salary-cal-nav__btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
  pointer-events: none;
}

.salary-cal-nav__year {
  font-family: 'Cormorant Garamond', 'Noto Serif KR', Georgia, serif;
  font-size: 38px;
  font-weight: 700;
  color: var(--mrt-text, #1c1917);
  letter-spacing: 0.02em;
  min-width: 120px;
  text-align: center;
  line-height: 1;
}

.salary-cal-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 14px;
}

@media (max-width: 1100px) {
  .salary-cal-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 640px) {
  .salary-cal-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }

  .salary-cal-nav__year {
    font-size: 30px;
  }
}

@media (max-width: 400px) {
  .salary-cal-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.salary-cal-cell {
  position: relative;
  border: 1px solid #e5e2dc;
  border-radius: 12px;
  background: #fff;
  min-height: 88px;
  padding: 16px 12px;
  cursor: pointer;
  font: inherit;
  text-align: center;
  transition:
    border-color 0.18s ease,
    box-shadow 0.18s ease,
    background 0.18s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.salary-cal-cell:hover {
  border-color: #c4beb4;
  box-shadow: 0 8px 24px rgba(28, 25, 23, 0.06);
  background: #fdfcfa;
}

.salary-cal-cell:active {
  transform: scale(0.99);
}

.salary-cal-cell--future {
  opacity: 0.38;
  cursor: not-allowed;
  pointer-events: none;
}

.salary-cal-cell__num {
  font-family: 'Cormorant Garamond', 'Noto Serif KR', Georgia, serif;
  font-size: clamp(26px, 3.2vw, 36px);
  font-weight: 700;
  color: #292524;
  line-height: 1;
}

.salary-cal-cell__label {
  font-size: 12px;
  font-weight: 600;
  color: #78716c;
  letter-spacing: 0.04em;
}

.salary-cal-cell--today {
  box-shadow: 0 0 0 1px rgba(139, 115, 85, 0.45);
}

.salary-cal-cell--today .salary-cal-cell__num {
  color: #1c1917;
}

/* 스크롤은 유지, 스크롤바만 숨김 */
.salary-hide-scrollbar {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.salary-hide-scrollbar::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}

/* 문서 오버레이 */
.salary-doc-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(28, 27, 26, 0.48);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  animation: salaryFadeIn 0.22s ease;
  overflow-y: auto;
  overflow-x: hidden;
}

@keyframes salaryFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes salaryPaperIn {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.salary-doc-shell {
  position: relative;
  width: 100%;
  max-width: min(96vw, 1140px);
  margin: auto;
  max-height: none;
  display: flex;
  flex-direction: column;
  animation: salaryPaperIn 0.34s cubic-bezier(0.22, 1, 0.36, 1);
}

.salary-doc-close {
  position: absolute;
  top: -48px;
  right: 0;
  width: 40px;
  height: 40px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.12);
  color: #fafaf9;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.salary-doc-close:hover {
  background: rgba(255, 255, 255, 0.22);
  border-color: rgba(255, 255, 255, 0.5);
}

.salary-doc-paper {
  --doc-ink: #1c2a33;
  --doc-ink-soft: #334155;
  --doc-muted: #64748b;
  --doc-brass: #8b7355;
  --doc-brass-faint: rgba(139, 115, 85, 0.14);
  --doc-sage: rgba(71, 85, 65, 0.06);
  background: linear-gradient(165deg, #f9f8f6 0%, #f4f2ee 48%, #f0eeea 100%);
  border-radius: 2px;
  box-shadow:
    0 0 0 1px rgba(30, 41, 59, 0.07),
    0 0 0 7px rgba(248, 246, 242, 0.95),
    0 28px 56px -14px rgba(30, 41, 59, 0.22);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: min(88vh, 900px);
}

.salary-doc-header {
  padding: 32px clamp(24px, 4vw, 44px) 26px;
  background: linear-gradient(180deg, #fdfcfa 0%, #f7f5f1 55%, #f3f1ed 100%);
  border-bottom: 3px double rgba(139, 115, 85, 0.22);
  position: relative;
}

.salary-doc-header::after {
  content: '';
  position: absolute;
  left: clamp(24px, 4vw, 44px);
  right: clamp(24px, 4vw, 44px);
  bottom: -5px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(139, 115, 85, 0.45) 22%, rgba(100, 116, 90, 0.35) 50%, rgba(139, 115, 85, 0.45) 78%, transparent);
  opacity: 0.9;
}

.salary-doc-header__top {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px 24px;
}

.salary-doc-header__titles {
  flex: 1 1;
  min-width: min(200px, 100%);
}

.salary-doc-header__ribbon {
  display: block;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: #5c6678;
  margin-bottom: 10px;
}

.salary-doc-header__title {
  margin: 0;
  font-family: 'Cormorant Garamond', 'Noto Serif KR', Georgia, serif;
  font-size: 28px;
  font-weight: 700;
  color: var(--doc-ink, #1c2a33);
  letter-spacing: 0.02em;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35em 0.5em;
}

.salary-doc-header__title-main {
  white-space: nowrap;
}

.salary-doc-header__title-emp {
  font-family: 'Noto Sans KR', 'Noto Serif KR', system-ui, sans-serif;
  font-weight: 600;
  font-size: 0.92em;
  letter-spacing: -0.02em;
  color: #3d4a5c;
}

.salary-doc-header__sums {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
  gap: 0;
  margin-left: 0;
  padding: 10px 18px 12px 22px;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.65) 0%, var(--doc-brass-faint, rgba(139, 115, 85, 0.12)) 55%, var(--doc-sage, rgba(71, 85, 65, 0.05)) 100%);
  border: 1px solid rgba(139, 115, 85, 0.14);
  border-radius: 12px;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.75) inset;
}

.salary-doc-header__sum {
  text-align: right;
  padding: 0;
  margin: 0;
  min-width: 7.5rem;
  padding-left: clamp(18px, 2.5vw, 30px);
  padding-right: clamp(4px, 1vw, 8px);
  border-left: 1px solid rgba(100, 116, 139, 0.18);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 4px;
}

.salary-doc-header__sum:first-child {
  border-left: none;
  padding-left: 0;
  min-width: 6.5rem;
}

.salary-doc-header__sum-label {
  display: block;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #5c6678;
  margin: 0;
  line-height: 1.25;
}

.salary-doc-header__sum-value {
  display: block;
  font-size: clamp(15px, 1.9vw, 18px);
  font-weight: 700;
  color: var(--doc-ink-soft, #334155);
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
  white-space: nowrap;
  line-height: 1.25;
  margin: 0;
}

.salary-doc-header__sum--net .salary-doc-header__sum-label {
  color: #4a5568;
}

.salary-doc-header__sum--net .salary-doc-header__sum-value {
  font-size: clamp(19px, 2.5vw, 26px);
  color: var(--doc-ink, #1c2a33);
  font-weight: 700;
}

.salary-doc-header__sub {
  margin-top: 16px;
  font-size: 13px;
  font-weight: 500;
  color: #5c6678;
  letter-spacing: 0.02em;
}

@media (max-width: 720px) {
  .salary-doc-header__top {
    grid-template-columns: 1fr;
  }

  .salary-doc-header__sums {
    width: 100%;
    justify-content: flex-start;
    align-items: stretch;
    flex-wrap: wrap;
    margin-top: 8px;
    padding: 14px 14px 16px;
    border-top: 1px solid rgba(139, 115, 85, 0.12);
    gap: 12px 10px;
  }

  .salary-doc-header__sum {
    border-left: none;
    padding-left: 0;
    padding-right: 12px;
    text-align: right;
    flex: 1 1;
    min-width: calc(33.33% - 10px);
  }

  .salary-doc-header__sum--net {
    min-width: 100%;
    border-top: 1px solid rgba(100, 116, 139, 0.12);
    padding-top: 16px;
    margin-top: 6px;
    padding-right: 0;
  }
}

.salary-doc-body {
  padding: 24px clamp(22px, 3.5vw, 48px) 32px;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1;
  min-height: 0;
  font-family: 'Noto Sans KR', system-ui, sans-serif;
}

.salary-doc-columns {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: clamp(16px, 2.5vw, 36px);
  align-items: start;
}

@media (max-width: 640px) {
  .salary-doc-columns {
    grid-template-columns: 1fr;
  }
}

.salary-doc-block {
  min-width: 0;
  border: 1px solid rgba(100, 116, 139, 0.14);
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.82);
  overflow: hidden;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.9) inset;
}

.salary-doc-block__head {
  padding: 12px 30px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #4a5568;
  background: linear-gradient(180deg, #f0f2f5 0%, #e8eaee 100%);
  border-bottom: 1px solid rgba(100, 116, 139, 0.12);
}

.salary-doc-rows {
  margin: 0;
  padding: 0;
  list-style: none;
}

/* 항목 많을 때: column-count 금지(폭 붕괴) → 2개 ul 그리드 */
.salary-doc-rows-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 0 clamp(14px, 2vw, 28px);
  align-items: start;
}

@media (max-width: 640px) {
  .salary-doc-rows-grid {
    grid-template-columns: 1fr;
  }
}

@media (min-width: 641px) {
  .salary-doc-rows-grid .salary-doc-rows--col:last-child .salary-doc-row:first-child {
    border-top: none;
  }
}

.salary-doc-rows--col {
  min-width: 0;
}

.salary-doc-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  column-gap: 12px;
  row-gap: 4px;
  padding: 9px 22px;
  font-size: 12px;
  border-top: 1px solid rgba(100, 116, 139, 0.08);
}

.salary-doc-row:first-child {
  border-top: none;
}

.salary-doc-rows .salary-doc-row:nth-child(even) {
  background: rgba(248, 246, 242, 0.65);
}

.salary-doc-row__name {
  min-width: 0;
  color: #475569;
  font-weight: 500;
  line-height: 1.45;
  word-break: keep-all;
  overflow-wrap: break-word;
  writing-mode: horizontal-tb;
}

.salary-doc-row__amt {
  justify-self: end;
  font-weight: 700;
  color: #1c2a33;
  text-align: right;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.salary-doc-empty {
  padding: 20px 30px;
  font-size: 12px;
  color: #a8a29e;
  text-align: center;
}

.salary-doc-memo {
  margin-top: 22px;
  padding: 14px 18px;
  font-size: 11px;
  line-height: 1.65;
  color: #5c6678;
  background: linear-gradient(90deg, rgba(139, 115, 85, 0.07) 0%, rgba(248, 246, 242, 0.9) 38%);
  border-left: 3px solid rgba(139, 115, 85, 0.45);
  border-radius: 0 6px 6px 0;
}

.salary-doc-loading,
.salary-doc-error {
  padding: 56px 28px;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: #78716c;
  font-family: 'Noto Sans KR', system-ui, sans-serif;
}

.salary-doc-error {
  color: #991b1b;
}

.salary-doc-stamp {
  margin-top: 26px;
  text-align: center;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.28em;
  color: #94a3b8;
  text-transform: uppercase;
}

/* ── 급여명세서 하단: 출장·특근 정산 + 근태 이력 ── */
.salary-att {
  margin-top: 22px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.salary-att-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.salary-att-head__sum {
  letter-spacing: 0.02em;
  text-transform: none;
  font-weight: 800;
  color: #1c2a33;
}
.salary-att-settle {
  overflow-x: auto;
}
.salary-att-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11.5px;
  color: #1c2a33;
}
.salary-att-table th {
  padding: 7px 10px;
  text-align: left;
  font-weight: 700;
  font-size: 11px;
  color: #334155;
  background: rgba(139, 115, 85, 0.07);
  border-bottom: 1px solid rgba(100, 116, 139, 0.18);
  white-space: nowrap;
}
.salary-att-table td {
  padding: 6px 10px;
  border-bottom: 1px solid rgba(100, 116, 139, 0.1);
  vertical-align: middle;
}
.salary-att-table tbody tr:nth-child(even) td {
  background: rgba(248, 246, 242, 0.7);
}
.salary-att-table tfoot td {
  padding: 8px 10px;
  font-weight: 700;
  color: #334155;
  border-top: 2px solid rgba(139, 115, 85, 0.3);
  border-bottom: none;
}
.salary-att-table .r { text-align: right; }
.salary-att-table .b { font-weight: 800; }
.salary-att-table .nowrap { white-space: nowrap; }
.salary-att-table tr.is-weekend td:first-child { color: #b91c1c; }
.salary-att-dates {
  color: #475569;
  font-size: 11px;
  line-height: 1.5;
}
.salary-att-place {
  max-width: 220px;
  color: #475569;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.salary-att-tag,
.salary-att-trip {
  display: inline-block;
  margin: 1px 4px 1px 0;
  padding: 1px 7px;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 700;
  white-space: nowrap;
}
.salary-att-tag {
  color: #3730a3;
  background: #e0e7ff;
}
.salary-att-tag--pending {
  color: #9a3412;
  background: #ffedd5;
}
.salary-att-trip {
  color: #155e75;
  background: #cffafe;
}
.salary-att-empty {
  margin-top: 18px;
  padding: 12px;
  font-size: 11.5px;
  color: #64748b;
  text-align: center;
}

/* ── 모바일: 명세서 전체화면 + 근태/정산 표를 카드형으로 ── */
@media (max-width: 640px) {
  .salary-doc-backdrop {
    padding: 0;
    align-items: stretch;
    backdrop-filter: none;
  }
  .salary-doc-shell {
    max-width: 100%;
    margin: 0;
  }
  .salary-doc-close {
    position: fixed;
    top: max(10px, env(safe-area-inset-top));
    right: 10px;
    z-index: 3;
    width: 36px;
    height: 36px;
    font-size: 20px;
    color: #1c2a33;
    background: rgba(255, 255, 255, 0.92);
    border-color: rgba(100, 116, 139, 0.3);
    box-shadow: 0 2px 8px rgba(30, 41, 59, 0.15);
  }
  .salary-doc-paper {
    min-height: 100vh;
    min-height: 100dvh;
    max-height: 100vh;
    max-height: 100dvh;
    border-radius: 0;
    box-shadow: none;
  }
  .salary-doc-header {
    padding: 18px 16px 16px;
    padding-top: max(18px, env(safe-area-inset-top));
  }
  .salary-doc-header::after {
    left: 16px;
    right: 16px;
  }
  .salary-doc-header__ribbon {
    margin-bottom: 6px;
    padding-right: 44px;
  }
  .salary-doc-header__title {
    font-size: 22px;
    padding-right: 44px;
  }
  .salary-doc-header__sums {
    padding: 12px;
    gap: 10px 8px;
  }
  .salary-doc-header__sum {
    min-width: calc(50% - 8px);
    padding-right: 0;
  }
  .salary-doc-header__sum:first-child {
    min-width: calc(50% - 8px);
  }
  .salary-doc-header__sum-value {
    font-size: 16px;
  }
  .salary-doc-header__sum--net .salary-doc-header__sum-value {
    font-size: 22px;
  }
  .salary-doc-header__sub {
    margin-top: 10px;
    font-size: 12px;
  }
  .salary-doc-body {
    padding: 14px 12px calc(24px + env(safe-area-inset-bottom));
    -webkit-overflow-scrolling: touch;
  }
  .salary-doc-columns {
    gap: 12px;
  }
  .salary-doc-block__head {
    padding: 10px 14px;
  }
  .salary-doc-row {
    padding: 9px 14px;
    font-size: 13px;
  }
  .salary-doc-row__amt {
    font-size: 13px;
  }
  .salary-doc-memo {
    margin-top: 14px;
    padding: 10px 12px;
    font-size: 12px;
  }
  .salary-doc-stamp {
    margin-top: 18px;
  }

  .salary-att {
    margin-top: 14px;
    gap: 12px;
  }
  .salary-att-head {
    flex-wrap: wrap;
    gap: 4px 10px;
  }
  .salary-att-settle {
    overflow: visible;
  }
  .salary-att-table thead {
    display: none;
  }
  .salary-att-table,
  .salary-att-table tbody,
  .salary-att-table tfoot {
    display: block;
    width: 100%;
  }
  .salary-att-table tbody tr,
  .salary-att-table tfoot tr {
    display: grid;
    padding: 10px 14px;
    border-bottom: 1px solid rgba(100, 116, 139, 0.12);
    column-gap: 10px;
    row-gap: 3px;
  }
  .salary-att-table td {
    padding: 0;
    border: none;
    background: none !important;
    min-width: 0;
  }
  .salary-att-table tbody tr:nth-child(even) {
    background: rgba(248, 246, 242, 0.7);
  }

  /* 정산: [구분 항목 | 금액] / [횟수 × 단가] / [발생일] */
  .salary-att-table--settle tbody tr {
    grid-template-columns: auto minmax(0, 1fr) auto;
    grid-template-areas:
      'kind item amt'
      'cnt  cnt  unit'
      'dates dates dates';
    font-size: 13px;
  }
  .salary-att-table--settle .att-s-kind {
    grid-area: kind;
    font-size: 11px;
    font-weight: 700;
    color: #64748b;
    align-self: center;
  }
  .salary-att-table--settle .att-s-item {
    grid-area: item;
    font-weight: 700;
  }
  .salary-att-table--settle .att-s-amt {
    grid-area: amt;
    font-size: 14px;
  }
  .salary-att-table--settle .att-s-cnt {
    grid-area: cnt;
    text-align: left;
    font-size: 12px;
    color: #475569;
  }
  .salary-att-table--settle .att-s-unit {
    grid-area: unit;
    font-size: 12px;
    color: #475569;
  }
  .salary-att-table--settle .att-s-unit::before {
    content: '단가 ';
  }
  .salary-att-table--settle .att-s-unit--none {
    display: none;
  }
  .salary-att-table--settle .att-s-dates {
    grid-area: dates;
    font-size: 11.5px;
  }
  .salary-att-table--settle tfoot tr {
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas: 'label amt';
    border-top: 2px solid rgba(139, 115, 85, 0.3);
    border-bottom: none;
  }
  .salary-att-table--settle .att-s-foot-label {
    grid-area: label;
    font-size: 11.5px;
    align-self: center;
  }
  .salary-att-table--settle .att-s-foot-amt {
    grid-area: amt;
    font-size: 15px;
    color: #1c2a33;
  }
  .salary-att-table--settle .att-s-foot-pad {
    display: none;
  }

  /* 근태: [일자 | 출근 | 퇴근 | 출장비] / [출근 위치] / [퇴근 위치] / [태그] */
  .salary-att-table--days tbody tr {
    grid-template-columns: auto auto auto minmax(0, 1fr);
    grid-template-areas:
      'date go leave amt'
      'gp gp gp gp'
      'lp lp lp lp'
      'tags tags tags tags';
    font-size: 13px;
    align-items: center;
  }
  .salary-att-table--days .att-d-date {
    grid-area: date;
    font-weight: 800;
    min-width: 72px;
  }
  .salary-att-table--days .att-d-go { grid-area: go; }
  .salary-att-table--days .att-d-leave { grid-area: leave; }
  .salary-att-table--days .att-d-go::before,
  .salary-att-table--days .att-d-leave::before {
    margin-right: 3px;
    font-size: 10.5px;
    font-weight: 700;
    color: #64748b;
  }
  .salary-att-table--days .att-d-go::before { content: '출'; }
  .salary-att-table--days .att-d-leave::before { content: '퇴'; }
  .salary-att-table--days .att-d-amt {
    grid-area: amt;
    font-weight: 700;
  }
  .salary-att-table--days .att-d-goplace,
  .salary-att-table--days .att-d-leaveplace {
    max-width: none;
    font-size: 11.5px;
  }
  .salary-att-table--days .att-d-goplace { grid-area: gp; }
  .salary-att-table--days .att-d-leaveplace { grid-area: lp; }
  .salary-att-table--days .att-d-goplace::before { content: '출근 · '; color: #94a3b8; }
  .salary-att-table--days .att-d-leaveplace::before { content: '퇴근 · '; color: #94a3b8; }
  .salary-att-table--days .att-d-goplace:empty,
  .salary-att-table--days .att-d-leaveplace:empty {
    display: none;
  }
  .salary-att-table--days .att-d-tags {
    grid-area: tags;
    margin-top: 2px;
  }
  .salary-att-table--days .att-d-tags.is-empty {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/MySalaryLeave.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAIlC,iBAAiB;AACjB;EACE,4BAA4B;AAC9B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,uCAAuC;EACvC,4CAA4C;EAC5C,mBAAmB;EACnB,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4CAA4C;EAC5C,kCAAkC;EAClC,+BAA+B;EAC/B,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB;;;yBAGuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kEAAkE;EAClE,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0DAA0D;AAC5D;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,2CAA2C;EAC3C,kCAAkC;EAClC,0EAA0E;EAC1E,kBAAkB;EAClB;;;4CAG0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,0EAA0E;EAC1E,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,sJAAsJ;EACtJ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mEAAmE;EACnE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,MAAM;EACN,cAAc;EACd,4BAA4B;EAC5B,qKAAqK;EACrK,0CAA0C;EAC1C,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,sCAAsC;EACtC,mCAAmC;EACnC,gDAAgD;EAChD,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,2BAA2B;IAC3B,oBAAoB;IACpB,eAAe;IACf,eAAe;IACf,uBAAuB;IACvB,8CAA8C;IAC9C,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,SAAO;IACP,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,+CAA+C;IAC/C,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,6DAA6D;EAC7D,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,oDAAoD;EACpD,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,6FAA6F;EAC7F,+CAA+C;EAC/C,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oCAAoC;EACpC,kDAAkD;EAClD,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,iDAAiD;EACjD,sBAAsB;AACxB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,6CAA6C;EAC7C,mBAAmB;AACrB;AACA,uBAAuB,iBAAiB,EAAE;AAC1C,uBAAuB,gBAAgB,EAAE;AACzC,4BAA4B,mBAAmB,EAAE;AACjD,iDAAiD,cAAc,EAAE;AACjE;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;EAEE,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE;IACE,UAAU;IACV,oBAAoB;IACpB,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,SAAS;EACX;EACA;IACE,eAAe;IACf,wCAAwC;IACxC,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;IACd,qCAAqC;IACrC,sCAAsC;IACtC,4CAA4C;EAC9C;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,uBAAuB;IACvB,gDAAgD;EAClD;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,aAAa;EACf;EACA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,2DAA2D;IAC3D,iCAAiC;EACnC;EACA;IACE,SAAS;EACX;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;EACA;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;;;IAGE,cAAc;IACd,WAAW;EACb;EACA;;IAEE,aAAa;IACb,kBAAkB;IAClB,kDAAkD;IAClD,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,UAAU;IACV,YAAY;IACZ,2BAA2B;IAC3B,YAAY;EACd;EACA;IACE,oCAAoC;EACtC;;EAEA,yCAAyC;EACzC;IACE,+CAA+C;IAC/C;;;yBAGqB;IACrB,eAAe;EACjB;EACA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;EACA;IACE,eAAe;IACf,eAAe;IACf,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,0CAA0C;IAC1C,gCAAgC;IAChC,6CAA6C;IAC7C,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;EACf;;EAEA,wDAAwD;EACxD;IACE,oDAAoD;IACpD;;;;2BAIuB;IACvB,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;EACA,oCAAoC,aAAa,EAAE;EACnD,uCAAuC,gBAAgB,EAAE;EACzD;;IAEE,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;EACA,4CAA4C,YAAY,EAAE;EAC1D,+CAA+C,YAAY,EAAE;EAC7D;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA,yCAAyC,aAAa,EAAE;EACxD,4CAA4C,aAAa,EAAE;EAC3D,iDAAiD,gBAAgB,EAAE,cAAc,EAAE;EACnF,oDAAoD,gBAAgB,EAAE,cAAc,EAAE;EACtF;;IAEE,aAAa;EACf;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["/* 급여명세 — 연도 달력(월 선택) + 고급 문서 모달 */\n\n@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,600;0,700;1,500&family=Noto+Sans+KR:wght@400;500;600;700&family=Noto+Serif+KR:wght@500;600;700&display=swap');\n\n/* 페이지 전체 가로 확장 */\n.salary-page .settings-wrap {\n  max-width: min(96vw, 1320px);\n}\n\n/* 급여 달력 + 연차 패널 가로 배치 */\n.salary-leave-split {\n  display: grid;\n  grid-template-columns: minmax(280px, 1fr) minmax(0, 1.15fr);\n  gap: 20px;\n  align-items: start;\n}\n\n.salary-leave-split .settings-card {\n  margin: 0;\n}\n\n@media (max-width: 1024px) {\n  .salary-leave-split {\n    grid-template-columns: 1fr;\n  }\n}\n\n.salary-cal-panel {\n  max-width: none;\n  width: 100%;\n  margin: 0 auto;\n  background: var(--mrt-surface, #fcfbfa);\n  border: 1px solid var(--mrt-border, #e8e6e3);\n  border-radius: 16px;\n  padding: 20px 22px 24px;\n  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.8) inset;\n}\n\n.salary-cal-hint {\n  margin: 0 0 18px;\n  font-size: 13px;\n  color: var(--mrt-muted, #78716c);\n  font-weight: 500;\n  line-height: 1.5;\n}\n\n.salary-cal-nav {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--mrt-border-2, #ebe8e4);\n}\n\n.salary-cal-nav__btn {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  border: 1px solid var(--mrt-border, #e0ddd8);\n  background: var(--mrt-bg, #f4f3f1);\n  color: var(--mrt-text, #1c1917);\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.salary-cal-nav__btn:hover {\n  background: #ebe9e6;\n  border-color: #d4d0c8;\n}\n\n.salary-cal-nav__btn:active {\n  transform: scale(0.98);\n}\n\n.salary-cal-nav__btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.salary-cal-nav__year {\n  font-family: 'Cormorant Garamond', 'Noto Serif KR', Georgia, serif;\n  font-size: 38px;\n  font-weight: 700;\n  color: var(--mrt-text, #1c1917);\n  letter-spacing: 0.02em;\n  min-width: 120px;\n  text-align: center;\n  line-height: 1;\n}\n\n.salary-cal-grid {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 14px;\n}\n\n@media (max-width: 1100px) {\n  .salary-cal-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media (max-width: 640px) {\n  .salary-cal-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n  }\n\n  .salary-cal-nav__year {\n    font-size: 30px;\n  }\n}\n\n@media (max-width: 400px) {\n  .salary-cal-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.salary-cal-cell {\n  position: relative;\n  border: 1px solid #e5e2dc;\n  border-radius: 12px;\n  background: #fff;\n  min-height: 88px;\n  padding: 16px 12px;\n  cursor: pointer;\n  font: inherit;\n  text-align: center;\n  transition:\n    border-color 0.18s ease,\n    box-shadow 0.18s ease,\n    background 0.18s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.salary-cal-cell:hover {\n  border-color: #c4beb4;\n  box-shadow: 0 8px 24px rgba(28, 25, 23, 0.06);\n  background: #fdfcfa;\n}\n\n.salary-cal-cell:active {\n  transform: scale(0.99);\n}\n\n.salary-cal-cell--future {\n  opacity: 0.38;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.salary-cal-cell__num {\n  font-family: 'Cormorant Garamond', 'Noto Serif KR', Georgia, serif;\n  font-size: clamp(26px, 3.2vw, 36px);\n  font-weight: 700;\n  color: #292524;\n  line-height: 1;\n}\n\n.salary-cal-cell__label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #78716c;\n  letter-spacing: 0.04em;\n}\n\n.salary-cal-cell--today {\n  box-shadow: 0 0 0 1px rgba(139, 115, 85, 0.45);\n}\n\n.salary-cal-cell--today .salary-cal-cell__num {\n  color: #1c1917;\n}\n\n/* 스크롤은 유지, 스크롤바만 숨김 */\n.salary-hide-scrollbar {\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.salary-hide-scrollbar::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n  display: none;\n}\n\n/* 문서 오버레이 */\n.salary-doc-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  background: rgba(28, 27, 26, 0.48);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  animation: salaryFadeIn 0.22s ease;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n@keyframes salaryFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes salaryPaperIn {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.salary-doc-shell {\n  position: relative;\n  width: 100%;\n  max-width: min(96vw, 1140px);\n  margin: auto;\n  max-height: none;\n  display: flex;\n  flex-direction: column;\n  animation: salaryPaperIn 0.34s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.salary-doc-close {\n  position: absolute;\n  top: -48px;\n  right: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  background: rgba(255, 255, 255, 0.12);\n  color: #fafaf9;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.salary-doc-close:hover {\n  background: rgba(255, 255, 255, 0.22);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.salary-doc-paper {\n  --doc-ink: #1c2a33;\n  --doc-ink-soft: #334155;\n  --doc-muted: #64748b;\n  --doc-brass: #8b7355;\n  --doc-brass-faint: rgba(139, 115, 85, 0.14);\n  --doc-sage: rgba(71, 85, 65, 0.06);\n  background: linear-gradient(165deg, #f9f8f6 0%, #f4f2ee 48%, #f0eeea 100%);\n  border-radius: 2px;\n  box-shadow:\n    0 0 0 1px rgba(30, 41, 59, 0.07),\n    0 0 0 7px rgba(248, 246, 242, 0.95),\n    0 28px 56px -14px rgba(30, 41, 59, 0.22);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  max-height: min(88vh, 900px);\n}\n\n.salary-doc-header {\n  padding: 32px clamp(24px, 4vw, 44px) 26px;\n  background: linear-gradient(180deg, #fdfcfa 0%, #f7f5f1 55%, #f3f1ed 100%);\n  border-bottom: 3px double rgba(139, 115, 85, 0.22);\n  position: relative;\n}\n\n.salary-doc-header::after {\n  content: '';\n  position: absolute;\n  left: clamp(24px, 4vw, 44px);\n  right: clamp(24px, 4vw, 44px);\n  bottom: -5px;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(139, 115, 85, 0.45) 22%, rgba(100, 116, 90, 0.35) 50%, rgba(139, 115, 85, 0.45) 78%, transparent);\n  opacity: 0.9;\n}\n\n.salary-doc-header__top {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 14px 24px;\n}\n\n.salary-doc-header__titles {\n  flex: 1;\n  min-width: min(200px, 100%);\n}\n\n.salary-doc-header__ribbon {\n  display: block;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: #5c6678;\n  margin-bottom: 10px;\n}\n\n.salary-doc-header__title {\n  margin: 0;\n  font-family: 'Cormorant Garamond', 'Noto Serif KR', Georgia, serif;\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--doc-ink, #1c2a33);\n  letter-spacing: 0.02em;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 0.35em 0.5em;\n}\n\n.salary-doc-header__title-main {\n  white-space: nowrap;\n}\n\n.salary-doc-header__title-emp {\n  font-family: 'Noto Sans KR', 'Noto Serif KR', system-ui, sans-serif;\n  font-weight: 600;\n  font-size: 0.92em;\n  letter-spacing: -0.02em;\n  color: #3d4a5c;\n}\n\n.salary-doc-header__sums {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: nowrap;\n  gap: 0;\n  margin-left: 0;\n  padding: 10px 18px 12px 22px;\n  background: linear-gradient(145deg, rgba(255, 255, 255, 0.65) 0%, var(--doc-brass-faint, rgba(139, 115, 85, 0.12)) 55%, var(--doc-sage, rgba(71, 85, 65, 0.05)) 100%);\n  border: 1px solid rgba(139, 115, 85, 0.14);\n  border-radius: 12px;\n  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.75) inset;\n}\n\n.salary-doc-header__sum {\n  text-align: right;\n  padding: 0;\n  margin: 0;\n  min-width: 7.5rem;\n  padding-left: clamp(18px, 2.5vw, 30px);\n  padding-right: clamp(4px, 1vw, 8px);\n  border-left: 1px solid rgba(100, 116, 139, 0.18);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: center;\n  gap: 4px;\n}\n\n.salary-doc-header__sum:first-child {\n  border-left: none;\n  padding-left: 0;\n  min-width: 6.5rem;\n}\n\n.salary-doc-header__sum-label {\n  display: block;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #5c6678;\n  margin: 0;\n  line-height: 1.25;\n}\n\n.salary-doc-header__sum-value {\n  display: block;\n  font-size: clamp(15px, 1.9vw, 18px);\n  font-weight: 700;\n  color: var(--doc-ink-soft, #334155);\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.02em;\n  white-space: nowrap;\n  line-height: 1.25;\n  margin: 0;\n}\n\n.salary-doc-header__sum--net .salary-doc-header__sum-label {\n  color: #4a5568;\n}\n\n.salary-doc-header__sum--net .salary-doc-header__sum-value {\n  font-size: clamp(19px, 2.5vw, 26px);\n  color: var(--doc-ink, #1c2a33);\n  font-weight: 700;\n}\n\n.salary-doc-header__sub {\n  margin-top: 16px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #5c6678;\n  letter-spacing: 0.02em;\n}\n\n@media (max-width: 720px) {\n  .salary-doc-header__top {\n    grid-template-columns: 1fr;\n  }\n\n  .salary-doc-header__sums {\n    width: 100%;\n    justify-content: flex-start;\n    align-items: stretch;\n    flex-wrap: wrap;\n    margin-top: 8px;\n    padding: 14px 14px 16px;\n    border-top: 1px solid rgba(139, 115, 85, 0.12);\n    gap: 12px 10px;\n  }\n\n  .salary-doc-header__sum {\n    border-left: none;\n    padding-left: 0;\n    padding-right: 12px;\n    text-align: right;\n    flex: 1;\n    min-width: calc(33.33% - 10px);\n  }\n\n  .salary-doc-header__sum--net {\n    min-width: 100%;\n    border-top: 1px solid rgba(100, 116, 139, 0.12);\n    padding-top: 16px;\n    margin-top: 6px;\n    padding-right: 0;\n  }\n}\n\n.salary-doc-body {\n  padding: 24px clamp(22px, 3.5vw, 48px) 32px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1;\n  min-height: 0;\n  font-family: 'Noto Sans KR', system-ui, sans-serif;\n}\n\n.salary-doc-columns {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: clamp(16px, 2.5vw, 36px);\n  align-items: start;\n}\n\n@media (max-width: 640px) {\n  .salary-doc-columns {\n    grid-template-columns: 1fr;\n  }\n}\n\n.salary-doc-block {\n  min-width: 0;\n  border: 1px solid rgba(100, 116, 139, 0.14);\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.82);\n  overflow: hidden;\n  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.9) inset;\n}\n\n.salary-doc-block__head {\n  padding: 12px 30px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #4a5568;\n  background: linear-gradient(180deg, #f0f2f5 0%, #e8eaee 100%);\n  border-bottom: 1px solid rgba(100, 116, 139, 0.12);\n}\n\n.salary-doc-rows {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n/* 항목 많을 때: column-count 금지(폭 붕괴) → 2개 ul 그리드 */\n.salary-doc-rows-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 0 clamp(14px, 2vw, 28px);\n  align-items: start;\n}\n\n@media (max-width: 640px) {\n  .salary-doc-rows-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (min-width: 641px) {\n  .salary-doc-rows-grid .salary-doc-rows--col:last-child .salary-doc-row:first-child {\n    border-top: none;\n  }\n}\n\n.salary-doc-rows--col {\n  min-width: 0;\n}\n\n.salary-doc-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  column-gap: 12px;\n  row-gap: 4px;\n  padding: 9px 22px;\n  font-size: 12px;\n  border-top: 1px solid rgba(100, 116, 139, 0.08);\n}\n\n.salary-doc-row:first-child {\n  border-top: none;\n}\n\n.salary-doc-rows .salary-doc-row:nth-child(even) {\n  background: rgba(248, 246, 242, 0.65);\n}\n\n.salary-doc-row__name {\n  min-width: 0;\n  color: #475569;\n  font-weight: 500;\n  line-height: 1.45;\n  word-break: keep-all;\n  overflow-wrap: break-word;\n  writing-mode: horizontal-tb;\n}\n\n.salary-doc-row__amt {\n  justify-self: end;\n  font-weight: 700;\n  color: #1c2a33;\n  text-align: right;\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n.salary-doc-empty {\n  padding: 20px 30px;\n  font-size: 12px;\n  color: #a8a29e;\n  text-align: center;\n}\n\n.salary-doc-memo {\n  margin-top: 22px;\n  padding: 14px 18px;\n  font-size: 11px;\n  line-height: 1.65;\n  color: #5c6678;\n  background: linear-gradient(90deg, rgba(139, 115, 85, 0.07) 0%, rgba(248, 246, 242, 0.9) 38%);\n  border-left: 3px solid rgba(139, 115, 85, 0.45);\n  border-radius: 0 6px 6px 0;\n}\n\n.salary-doc-loading,\n.salary-doc-error {\n  padding: 56px 28px;\n  text-align: center;\n  font-size: 13px;\n  font-weight: 500;\n  color: #78716c;\n  font-family: 'Noto Sans KR', system-ui, sans-serif;\n}\n\n.salary-doc-error {\n  color: #991b1b;\n}\n\n.salary-doc-stamp {\n  margin-top: 26px;\n  text-align: center;\n  font-size: 9px;\n  font-weight: 600;\n  letter-spacing: 0.28em;\n  color: #94a3b8;\n  text-transform: uppercase;\n}\n\n/* ── 급여명세서 하단: 출장·특근 정산 + 근태 이력 ── */\n.salary-att {\n  margin-top: 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.salary-att-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n.salary-att-head__sum {\n  letter-spacing: 0.02em;\n  text-transform: none;\n  font-weight: 800;\n  color: #1c2a33;\n}\n.salary-att-settle {\n  overflow-x: auto;\n}\n.salary-att-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 11.5px;\n  color: #1c2a33;\n}\n.salary-att-table th {\n  padding: 7px 10px;\n  text-align: left;\n  font-weight: 700;\n  font-size: 11px;\n  color: #334155;\n  background: rgba(139, 115, 85, 0.07);\n  border-bottom: 1px solid rgba(100, 116, 139, 0.18);\n  white-space: nowrap;\n}\n.salary-att-table td {\n  padding: 6px 10px;\n  border-bottom: 1px solid rgba(100, 116, 139, 0.1);\n  vertical-align: middle;\n}\n.salary-att-table tbody tr:nth-child(even) td {\n  background: rgba(248, 246, 242, 0.7);\n}\n.salary-att-table tfoot td {\n  padding: 8px 10px;\n  font-weight: 700;\n  color: #334155;\n  border-top: 2px solid rgba(139, 115, 85, 0.3);\n  border-bottom: none;\n}\n.salary-att-table .r { text-align: right; }\n.salary-att-table .b { font-weight: 800; }\n.salary-att-table .nowrap { white-space: nowrap; }\n.salary-att-table tr.is-weekend td:first-child { color: #b91c1c; }\n.salary-att-dates {\n  color: #475569;\n  font-size: 11px;\n  line-height: 1.5;\n}\n.salary-att-place {\n  max-width: 220px;\n  color: #475569;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.salary-att-tag,\n.salary-att-trip {\n  display: inline-block;\n  margin: 1px 4px 1px 0;\n  padding: 1px 7px;\n  border-radius: 999px;\n  font-size: 10.5px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.salary-att-tag {\n  color: #3730a3;\n  background: #e0e7ff;\n}\n.salary-att-tag--pending {\n  color: #9a3412;\n  background: #ffedd5;\n}\n.salary-att-trip {\n  color: #155e75;\n  background: #cffafe;\n}\n.salary-att-empty {\n  margin-top: 18px;\n  padding: 12px;\n  font-size: 11.5px;\n  color: #64748b;\n  text-align: center;\n}\n\n/* ── 모바일: 명세서 전체화면 + 근태/정산 표를 카드형으로 ── */\n@media (max-width: 640px) {\n  .salary-doc-backdrop {\n    padding: 0;\n    align-items: stretch;\n    backdrop-filter: none;\n  }\n  .salary-doc-shell {\n    max-width: 100%;\n    margin: 0;\n  }\n  .salary-doc-close {\n    position: fixed;\n    top: max(10px, env(safe-area-inset-top));\n    right: 10px;\n    z-index: 3;\n    width: 36px;\n    height: 36px;\n    font-size: 20px;\n    color: #1c2a33;\n    background: rgba(255, 255, 255, 0.92);\n    border-color: rgba(100, 116, 139, 0.3);\n    box-shadow: 0 2px 8px rgba(30, 41, 59, 0.15);\n  }\n  .salary-doc-paper {\n    min-height: 100vh;\n    min-height: 100dvh;\n    max-height: 100vh;\n    max-height: 100dvh;\n    border-radius: 0;\n    box-shadow: none;\n  }\n  .salary-doc-header {\n    padding: 18px 16px 16px;\n    padding-top: max(18px, env(safe-area-inset-top));\n  }\n  .salary-doc-header::after {\n    left: 16px;\n    right: 16px;\n  }\n  .salary-doc-header__ribbon {\n    margin-bottom: 6px;\n    padding-right: 44px;\n  }\n  .salary-doc-header__title {\n    font-size: 22px;\n    padding-right: 44px;\n  }\n  .salary-doc-header__sums {\n    padding: 12px;\n    gap: 10px 8px;\n  }\n  .salary-doc-header__sum {\n    min-width: calc(50% - 8px);\n    padding-right: 0;\n  }\n  .salary-doc-header__sum:first-child {\n    min-width: calc(50% - 8px);\n  }\n  .salary-doc-header__sum-value {\n    font-size: 16px;\n  }\n  .salary-doc-header__sum--net .salary-doc-header__sum-value {\n    font-size: 22px;\n  }\n  .salary-doc-header__sub {\n    margin-top: 10px;\n    font-size: 12px;\n  }\n  .salary-doc-body {\n    padding: 14px 12px calc(24px + env(safe-area-inset-bottom));\n    -webkit-overflow-scrolling: touch;\n  }\n  .salary-doc-columns {\n    gap: 12px;\n  }\n  .salary-doc-block__head {\n    padding: 10px 14px;\n  }\n  .salary-doc-row {\n    padding: 9px 14px;\n    font-size: 13px;\n  }\n  .salary-doc-row__amt {\n    font-size: 13px;\n  }\n  .salary-doc-memo {\n    margin-top: 14px;\n    padding: 10px 12px;\n    font-size: 12px;\n  }\n  .salary-doc-stamp {\n    margin-top: 18px;\n  }\n\n  .salary-att {\n    margin-top: 14px;\n    gap: 12px;\n  }\n  .salary-att-head {\n    flex-wrap: wrap;\n    gap: 4px 10px;\n  }\n  .salary-att-settle {\n    overflow: visible;\n  }\n  .salary-att-table thead {\n    display: none;\n  }\n  .salary-att-table,\n  .salary-att-table tbody,\n  .salary-att-table tfoot {\n    display: block;\n    width: 100%;\n  }\n  .salary-att-table tbody tr,\n  .salary-att-table tfoot tr {\n    display: grid;\n    padding: 10px 14px;\n    border-bottom: 1px solid rgba(100, 116, 139, 0.12);\n    column-gap: 10px;\n    row-gap: 3px;\n  }\n  .salary-att-table td {\n    padding: 0;\n    border: none;\n    background: none !important;\n    min-width: 0;\n  }\n  .salary-att-table tbody tr:nth-child(even) {\n    background: rgba(248, 246, 242, 0.7);\n  }\n\n  /* 정산: [구분 항목 | 금액] / [횟수 × 단가] / [발생일] */\n  .salary-att-table--settle tbody tr {\n    grid-template-columns: auto minmax(0, 1fr) auto;\n    grid-template-areas:\n      'kind item amt'\n      'cnt  cnt  unit'\n      'dates dates dates';\n    font-size: 13px;\n  }\n  .salary-att-table--settle .att-s-kind {\n    grid-area: kind;\n    font-size: 11px;\n    font-weight: 700;\n    color: #64748b;\n    align-self: center;\n  }\n  .salary-att-table--settle .att-s-item {\n    grid-area: item;\n    font-weight: 700;\n  }\n  .salary-att-table--settle .att-s-amt {\n    grid-area: amt;\n    font-size: 14px;\n  }\n  .salary-att-table--settle .att-s-cnt {\n    grid-area: cnt;\n    text-align: left;\n    font-size: 12px;\n    color: #475569;\n  }\n  .salary-att-table--settle .att-s-unit {\n    grid-area: unit;\n    font-size: 12px;\n    color: #475569;\n  }\n  .salary-att-table--settle .att-s-unit::before {\n    content: '단가 ';\n  }\n  .salary-att-table--settle .att-s-unit--none {\n    display: none;\n  }\n  .salary-att-table--settle .att-s-dates {\n    grid-area: dates;\n    font-size: 11.5px;\n  }\n  .salary-att-table--settle tfoot tr {\n    grid-template-columns: minmax(0, 1fr) auto;\n    grid-template-areas: 'label amt';\n    border-top: 2px solid rgba(139, 115, 85, 0.3);\n    border-bottom: none;\n  }\n  .salary-att-table--settle .att-s-foot-label {\n    grid-area: label;\n    font-size: 11.5px;\n    align-self: center;\n  }\n  .salary-att-table--settle .att-s-foot-amt {\n    grid-area: amt;\n    font-size: 15px;\n    color: #1c2a33;\n  }\n  .salary-att-table--settle .att-s-foot-pad {\n    display: none;\n  }\n\n  /* 근태: [일자 | 출근 | 퇴근 | 출장비] / [출근 위치] / [퇴근 위치] / [태그] */\n  .salary-att-table--days tbody tr {\n    grid-template-columns: auto auto auto minmax(0, 1fr);\n    grid-template-areas:\n      'date go leave amt'\n      'gp gp gp gp'\n      'lp lp lp lp'\n      'tags tags tags tags';\n    font-size: 13px;\n    align-items: center;\n  }\n  .salary-att-table--days .att-d-date {\n    grid-area: date;\n    font-weight: 800;\n    min-width: 72px;\n  }\n  .salary-att-table--days .att-d-go { grid-area: go; }\n  .salary-att-table--days .att-d-leave { grid-area: leave; }\n  .salary-att-table--days .att-d-go::before,\n  .salary-att-table--days .att-d-leave::before {\n    margin-right: 3px;\n    font-size: 10.5px;\n    font-weight: 700;\n    color: #64748b;\n  }\n  .salary-att-table--days .att-d-go::before { content: '출'; }\n  .salary-att-table--days .att-d-leave::before { content: '퇴'; }\n  .salary-att-table--days .att-d-amt {\n    grid-area: amt;\n    font-weight: 700;\n  }\n  .salary-att-table--days .att-d-goplace,\n  .salary-att-table--days .att-d-leaveplace {\n    max-width: none;\n    font-size: 11.5px;\n  }\n  .salary-att-table--days .att-d-goplace { grid-area: gp; }\n  .salary-att-table--days .att-d-leaveplace { grid-area: lp; }\n  .salary-att-table--days .att-d-goplace::before { content: '출근 · '; color: #94a3b8; }\n  .salary-att-table--days .att-d-leaveplace::before { content: '퇴근 · '; color: #94a3b8; }\n  .salary-att-table--days .att-d-goplace:empty,\n  .salary-att-table--days .att-d-leaveplace:empty {\n    display: none;\n  }\n  .salary-att-table--days .att-d-tags {\n    grid-area: tags;\n    margin-top: 2px;\n  }\n  .salary-att-table--days .att-d-tags.is-empty {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
